import React, { FC } from 'react';
import clsx from 'clsx';

const NuiDate: FC<{ otherClass?: string }> = ({ otherClass, children }) =>
    children ? <time className={clsx(otherClass, 'c-black-25 pr-5')}>{children}</time> : null;

export default NuiDate;
